import { WORLD_HEIGHT } from '../config/tuning.js';

/**
 * Converts world units (visible height = 1000 WU) to pixels of the current game size.
 * Keeps all gameplay code resolution independent: the projection (1920×1080),
 * a 4K player and a phone in portrait all play identically.
 */
export class WorldScale {
  /** pixels per world unit */
  readonly k: number;
  /** visible width in world units */
  readonly worldWidth: number;

  constructor(
    readonly pixelWidth: number,
    readonly pixelHeight: number,
    /** visible height in world units – less than 1000 zooms in (everything appears larger) */
    readonly worldHeight: number = WORLD_HEIGHT,
  ) {
    this.k = pixelHeight / worldHeight;
    this.worldWidth = pixelWidth / this.k;
  }

  /** world units → pixels */
  px(wu: number): number {
    return wu * this.k;
  }

  /** pixels → world units */
  wu(px: number): number {
    return px / this.k;
  }
}
